export var DEFAULT_JSON_MENU = 'http://localhost:3000';
//# sourceMappingURL=config.js.map